import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-polyglot'
import { submitProcessingAgency, closeEditProcessingAgencyModal } from '../../../actions/masters/masters'
import ProcessingAgencyMasterModal from '../../../components/masters/processing/ProcessingAgencyMasterModal'

export function mapStateToProps (state) {
  const processingAgencyModal = state.processingAgency.processingAgencyModal
  return {
    showModal: processingAgencyModal.showModal,
    agency: processingAgencyModal.agency,
    combos: {
      UOTreeCombo: state.combos.UOTreeCombo
    }
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      submitProcessingAgency,
      closeEditProcessingAgencyModal
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(ProcessingAgencyMasterModal))
